import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import StyledHint from './StyledHint';
import StyledIcon from './StyledIcon';
import StyledText from './StyledText';

interface IHint extends React.HTMLAttributes<HTMLDivElement> {
  text?: string;
  small?: boolean;
}

const Hint: React.FC<IHint> = ({ text, children, ...props }: IHint) => {
  return (
    <StyledHint {...props}>
      <StyledIcon>
        <FontAwesomeIcon icon={faInfoCircle} />
      </StyledIcon>
      {children ? (
        <StyledText small={props.small}>{children}</StyledText>
      ) : (
        <StyledText small={props.small}>{text}</StyledText>
      )}
    </StyledHint>
  );
};

export default Hint;
